import React, { useCallback, useContext, useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { ProductCard } from "components/ui";
import { useParams } from "react-router-dom";
import { useGetSingleCataloProducts } from "features/catalogue/hooks/useGetSingleCatalogProducts";
import { transformData, transformDataForTrayModal } from "utils/transformdata";
import CatalogueCardSkeleton from "features/catalogue/components/CatalogueCardSkeleton";
import { useInView } from "react-intersection-observer";
import { ReactComponent as Background } from "assets/icons/bg.svg";
import config from "configs/config";
import apiClient from "lib/api-client";
import { useFilter } from "context/FilterContext";
import SortContext from "context/SortContext";
import { useGlobalContext } from "context/GlobalContext";
import { useSettingContext } from "context/SettingContext";

const CatalogProductArchiveScreen = () => {
  const { id } = useParams();
  const [sliderLoading, setSliderLoading] = useState(true);
  const { setFilterValues, setBackendFilterValues, filterValues, setFilter, setAppliedFilterValues, setFilterCount } = useFilter();
  const { selectedSortValue, setSelectedSortValue } = useContext(SortContext);

  const { setSortOptions, sortOptions, setSearchPlaceHolder } = useGlobalContext();
  const { search, setSearch, setSearchBar } = useSettingContext();
   const isHidden = filterValues && filterValues["Show Hidden Designs"];
  const sort = sortOptions?.find((item) => item?.id == selectedSortValue);

  const {
    data: newData,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
  } = useGetSingleCataloProducts({ catalogId: id, limit: 10, search: search, isArchive: true, filterBy: filterValues || {}, sortBy: sort?.sortBy || "", order: sort?.order || "" , isHidden:!isHidden});
  const { ref, inView } = useInView({
    threshold: 1.0,
  });

  const isFetchNextPage = useCallback(() => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [hasNextPage, isFetchingNextPage, fetchNextPage]);

  useEffect(() => {
    if (inView) {
      isFetchNextPage();
    }
  }, [inView, isFetchNextPage]);

  useEffect(() => {
    setSearchPlaceHolder("Search By Design Number");
    setSearchBar(true);
    setFilter(true);
    setSortOptions([
      { id: 1, name: "Design No. (Low to High)", sortBy: "Design No", order: "asc" },
      { id: 2, name: "Design No. (High to Low)", sortBy: "Design No", order: "desc" },
      { id: 3, name: "Design Date (Oldest to Newest)", sortBy: "Design Date", order: "asc" },
      { id: 4, name: "Design Date (Newest to Oldest)", sortBy: "Design Date", order: "desc" },
      { id: 5, name: "Gold Net Weight (Low to High)", sortBy: "Gold Net Weight", order: "asc" },
      { id: 6, name: "Gold Net Weight (High to Low)", sortBy: "Gold Net Weight", order: "desc" },
      { id: 7, name: "Diamond Weight (Low to High)", sortBy: "Diamond Weight", order: "asc" },
      { id: 8, name: "Diamond Weight (High to Low)", sortBy: "Diamond Weight", order: "desc" },
      { id: 9, name: "Sales (Low to High)", sortBy: "Sales", order: "asc", access: true },
      { id: 10, name: "Sales (High to Low)", sortBy: "Sales", order: "desc", access: true },
    ]);

    const fetchFilterData = async () => {
      try {
        const response = await apiClient.post(`${config?.baseUrl}/api/v1/collection/getDesignSlidersData`, {
          catalogueId: id,
          isArchive: true,
        });

        if (response?.status === 200) {
          setSliderLoading(false);
          const { diamondPieces, diamondWeight, grossWeight, netWeight } = response.data.data;
          let filterData = {
            "Ratio": [0,10.3],
            "Diamond Pieces": diamondPieces || [0, 100],
            "Diamond Weight": diamondWeight || [0, 100],
            "Gold Gross-Weight": grossWeight || [0, 100],
            "Gold Net-Weight": netWeight || [0, 100],
            "Design In Collection": ["All"],
            "Design In Sets": ["All"],
            "Best Seller Design": ["All"],
            "Product Page Stock Status": ["All"],
            "Highest Seller": ["Gold", "Silver", "Bronze"],
            Labour: ["R", "X", "X2", "X5", "X8", "XX"],
            Class: ["Gold", "Silver", "Bronze", "Under Ratio"],
            "Show Hidden Designs":false
          };
          // Update the state with the fetched data
          setBackendFilterValues(filterData);
          setFilterValues(filterData);

          if (sessionStorage.getItem("filterChangeCount") == 0) {
            setFilterValues(filterData);
          } else {
            setFilterValues(JSON.parse(sessionStorage.getItem("appliedFilterValues")));
          }
        }
      } catch (error) {
        console.error("Error fetching filter data:", error);
      }
    };

    fetchFilterData();

    return () => {
      setFilter(false);
      setFilterValues({
        "Diamond Pieces": [],
        "Diamond Weight": [],
        "Gold Gross-Weight": [],
        "Gold Net-Weight": [],
        "Design In Collection": [],
        "Design In Sets": [],
        "Best Seller Design": [],
        "Stock status": [],
        "Highest Seller": [],
        Labour: [],
        Class: [],
      });
      setFilterCount(0);
      setAppliedFilterValues({});
      setSortOptions([]);
      setSelectedSortValue(null);
      setSearchPlaceHolder("");
      setSearchBar(false);
    };
  }, []);

  if (isLoading) {
    return (
      <Grid
        container
        className="Grid-padding"
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ flex: "1 1 1", display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "32px", rowGap: "32px" }}
      >
        {Array.from({ length: 4 }, (_, index) => (
          <CatalogueCardSkeleton key={index} item={{ id: index }} />
        ))}
      </Grid>
    );
  }

  return (
    <>
      {newData?.pages[0]?.catalogProducts.length > 0 ? (
        <Grid
          container
          className="Grid-padding"
          direction="row"
          justifyContent="space-between"
          sx={{
            paddingLeft: "18px",
            paddingRight: "18px",
            // maxHeight: "78vh",
            // overflowY: "scroll",
            // "&::-webkit-scrollbar": {
            //   width: "0px",
            // },
            // "&::-webkit-scrollbar-thumb": {
            //   background: "transparent",
            // },
            scrollbarWidth: "none", // For Firefox
            flex: "1 1 1",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: "32px",
            rowGap: "32px",
          }}
        >
          {newData?.pages.map((page) =>
            page?.catalogProducts?.map((design, index) => {
              // const curElement = transformData(design);
              let curElement = transformDataForTrayModal(design);
              return (
                <Grid key={index + "-" + curElement.id} item className="product">
                  <ProductCard key={index} data={curElement} style={{ maxWidth: "474px", minWidth: "474px" }} />
                </Grid>
              );
            })
          )}
          {isFetchingNextPage && <div style={{ color: "red" }} />}
          {isFetchingNextPage && Array.from({ length: 1 }, (_, index) => <CatalogueCardSkeleton key={index} item={{ id: index }} />)}
          <div ref={ref} />
        </Grid>
      ) : (
        <div
          style={{
            display: "flex",
            textAlign: "center",
            // padding: "40px",
            margin: "auto",
            padding: "auto",
            justifyContent: "center",
            alignItems: "center",
            height: "78vh",
          }}
        >
          <Background />
        </div>
      )}
    </>
  );
};

export default CatalogProductArchiveScreen;
